import styled from 'styled-components';
import { VisibilityControl } from 'components/shared/VisibilityControl';

export const MapVisibilityControl = styled(VisibilityControl)`
  height: 92vh;
  width: 100%;
  padding-right: 1rem;
`;
